module.exports = promise => 
  promise
  .then( data => [null, data] )
  .catch( err => Promise.resolve([err, null]) )